<template>
<div>
  <img :src="logoUrl" style="margin: 0px;padding: 4px 0px;width: 130px;position: absolute;top: 5px;left: 16px;z-index: 1;" />
  <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs_v1">    
    <el-tab-pane label="首页" name="first">
      <div :style="body_div" class="body_div">
        <div class="left_div">
          <img :src="longin_img" style="margin: 20% 0% 0% 40%;width:500px;height:370px;"/>
        </div>
        <div class="right_div">
          <div style="margin: 20% 0% 0% 15%;width:370px;height:370px;background: #FFFFFF;border-radius: 8px 8px 8px 8px;">
            <el-tabs v-model="login_type" class="tabs_v2">
              <el-tab-pane label="密码登录" name="password">
                <div class="tabs__content">
                  <el-form :model="principal" :rules="rules" ref="principal">
                    <el-form-item prop="account" style="margin-top: 36px;margin-bottom: 0px;height:40px;">
                          <el-input
                            size="mini"
                            clearable
                            placeholder="请输入用户名"
                            v-model="principal.account"
                          ></el-input>
                        </el-form-item>
                      <el-form-item prop="password" style="margin-top: 36px;margin-bottom: 0px;">
                        <el-input
                          type="password"
                          clearable
                          @keyup.enter.native="submitForm('principal')"
                          @focus="inputGetFocus"
                          size="mini"
                          placeholder="请输入密码"
                          v-model="principal.password"
                        ></el-input>
                      </el-form-item>
                  </el-form>
                  <div class="btn_wrap">
                    <div>
                      <el-button
                        size="medium"
                        type="primary"
                        @focus="inputGetFocus"
                        @click="submitForm('principal')"
                        :loading="loading"
                        class="login_btn"
                        >登录</el-button>
                      <el-button
                        size="medium"
                        @click="resetForm('principal')"
                        :disabled="loading"
                        class="login_btn"
                        style="margin-left: 24px;">重置</el-button>
                        <p style="padding-top: 24px !important;padding-right: 32px !important; padding-bottom: 8px !important;font-family: PingFang SC, PingFang SC;font-weight: 400;font-size: 14px;color: #82838D;line-height: 22px;text-align: left;font-style: normal;text-transform: none;">
                          如点击功能无反应，请按【ctrl + f5】刷新浏览器缓冲重试。</p>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="手机号登录" name="mobile">
                <div class="tabs__content">
                  <el-form :model="principal" ref="principal">
                    <el-form-item prop="account" style="margin-top: 36px;margin-bottom: 0px;height:40px;">
                          <el-input
                            size="mini"
                            clearable
                            placeholder="请输入手机号码"
                            v-model="principal.mobile"
                          ></el-input>
                        </el-form-item>
                      <el-form-item prop="password" style="margin-top: 36px;margin-bottom: 0px;">
                        <el-input
                          type="text"
                          @keyup.enter.native="submitForm_mobile()"
                          @focus="inputGetFocus"
                          size="mini"
                          placeholder="请输入验证码"
                          v-model="principal.code"
                          class="mobile"
                        >
                        <template slot="append">
                          <el-button @click="sendCode">{{message}}</el-button>
                        </template>
                        </el-input>
                      </el-form-item>
                  </el-form>
                  <div class="btn_wrap">
                    <div>
                      <el-button
                        size="medium"
                        type="primary"
                        @focus="inputGetFocus"
                        @click="submitForm_mobile()"
                        :loading="loading"
                        class="login_btn"
                        >登录</el-button>
                      <el-button
                        size="medium"
                        @click="resetForm('principal')"
                        :disabled="loading"
                        class="login_btn"
                        style="margin-left: 24px;">重置</el-button>
                        <p style="padding-top: 24px !important;padding-right: 32px !important; padding-bottom: 8px !important;font-family: PingFang SC, PingFang SC;font-weight: 400;font-size: 14px;color: #82838D;line-height: 22px;text-align: left;font-style: normal;text-transform: none;">
                          如点击功能无反应，请按【ctrl + f5】刷新浏览器缓冲重试。</p>
                    </div>
                  </div>
                </div>
                <el-dialog title="选择登录用户" :visible.sync="dialogTableVisible" width="30%">
                  <el-table :data="loginuser" label="你注册了以下单位，请点击对应单位进入系统。">
                    <el-table-column property="account" label="账号">
                      <template slot-scope="scope">
                        <span @click="accountLogin(scope.row.account)">{{scope.row.account}}-{{scope.row.fullname}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-dialog>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </el-tab-pane>
    <el-tab-pane label="品牌招商" name="second">
      <div :style="body_div" class="body_div">
        <div class="left_div">
          <img :src="longin_img" style="margin: 20% 0% 0% 40%;width:500px;height:370px;"/>
        </div>
        <div class="right_div">
          <el-form ref="form" :model="form" label-width="140px" style="margin: 0% 0% 0% 15%;width:460px;height:510px;background: rgb(255, 255, 255);border-radius: 8px;padding: 8px;">
            <el-form-item label="请选择报名门店" prop="fdmc" :rules="{required: true, message: '请选择报名门店', trigger: 'blur'}">
              <el-select v-model="form.fdmc" placeholder="请选择报名门店" >
                <el-option label="深圳海雅缤纷城" value="深圳海雅缤纷城"></el-option>
                <el-option label="中山海雅缤纷天地" value="中山海雅缤纷天地"></el-option>
                <el-option label="深圳南山海雅百货" value="深圳南山海雅百货"></el-option>
                <el-option label="东莞东城海雅百货" value="东莞东城海雅百货"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="您的预留姓名" prop="xm" :rules="{required: true, message: '请输入您的预留姓名', trigger: 'blur'}">
              <el-input v-model="form.xm"></el-input>
            </el-form-item>

            <el-form-item label="您的联系方式" prop="lxfs" :rules="{required: true, message: '请输入您的联系方式', trigger: 'blur'}">
              <el-input v-model="form.lxfs"></el-input>
            </el-form-item>

            <el-form-item label="您的需求面积（㎡）" prop="xqmj" :rules="{required: true, message: '请输入您的需求面积', trigger: 'blur'}">
              <el-input v-model="form.xqmj" type="number"></el-input>
            </el-form-item>

            <el-form-item label="您的需求位置">
              <el-input v-model="form.xqwz"></el-input>
            </el-form-item>

            <el-form-item label="您的品牌品类">
              <el-select v-model="form.pppl" placeholder="请选择品牌品类">
                <el-option label="化妆名品" value="化妆名品"></el-option>
                <el-option label="零售配套" value="零售配套"></el-option>
                <el-option label="餐饮茶咖" value="餐饮茶咖"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="您的职务">
              <el-input v-model="form.zw"></el-input>
            </el-form-item>
        
            <el-form-item label="备注说明">
              <el-input type="textarea" v-model="form.bz"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="onSubmit('form')">立即报名</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-tab-pane>
    <el-tab-pane label="信息公告" name="third">
      <haiyaMails></haiyaMails>
    </el-tab-pane>
    <el-tab-pane label="关于我们" name="fourth">
      <newsText></newsText>
    </el-tab-pane>
    <div style="    position: absolute;
    left: 40%;
    z-index: 1;
    bottom: 0px;
    font-size: 14px;"><a href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备17017770号-1 Copyright @ 2014-2030 Powered by 深圳市海雅商业有限公司</a></div>
  </el-tabs>
</div>
</template>

<script>
import langSelect from "@/components/langSelect";
import haiyaMails from "@/components/flow/haiyaMails";
import newsText from "@/components/flow/newsText";

export default {
  name: "login",
  props: ["tenant"],
  data() {
    var checkAccount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入账号"));
      }
      if (/^[a-zA-Z0-9_-]{2,20}$/.test(value)) {
        return callback();
      } else {
        return callback(new Error("账号格式不符合规范"));
      }
    };
    return {
      loginuser:[],
      dialogTableVisible: false,
      logo: "",
      name: "宏天企业信息平台",
      showTenant: false,
      showLogo: false,
      companyName: "",
      tenantName: "",
      principal: {
        account: "",
        password: "",
        mobile: "",
        code: ""
      },
      rules: {
        account: [{ validator: checkAccount, trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      responseError: "",
      loading: false,
      leftDivStyle: {
        background: `url(${require("@/assets/img/login.png")})  no-repeat right`,
      },
      rightDivStyle: {
        background: `url(${require("@/assets/img/back_right.png")})  no-repeat 0 0`,
      },
      mobileImg: require("@/assets/img/code.png"),
      logoUrl: `${require("@/assets/img/20241021141605.png")}`,
      userUrl: `${require("@/assets/img/user.png")}`,
      pwdUrl: `${require("@/assets/img/password.png")}`,
      isIeExplorer: false,
      longin_img:`${require("@/assets/img/login.png")}`,
      activeName: 'first',
      login_type:'password',
      body_div:{
        background: '#EDF3FA',
        height:(window.innerHeight-56)+"px"
      },
      timer: null,
      count: 60, // 验证码有效时间（秒）
      message: '获取验证码',
      mobileCode:'',
      form: {
          fdmc: '',
          xm: '',
          lxfs: '',
          xqmj: '',
          pppl:'',
          xqwz: '',
          zw: '',
          bz: ''
      }
    };
  },
  mounted() {
    //获取租户信息
    let tenant = this.tenant;
    if (tenant) {
      let url = "${uc}/uc/tenantManage/v1/getTenantByCode?code=" + tenant;
      let _this = this;
      this.$http.get(url).then((resp) => {
        if (resp.data) {
          let tenantManage = resp.data;
          _this.showTenant = true;
          _this.companyName = tenantManage.name;
          if (tenantManage.ico) {
            let ico = JSON.parse(tenantManage.ico);
            if (ico && ico.length > 0) {
              _this.showLogo = true;
              _this.logo = window.context.portal + "/system/file/v1/downloadFile?fileId=" + ico[0].id;
            }
          }
        }
      });
    } else {
      //不是租户
      this.sysSetting();
    }
  },
  methods: {
    accountLogin(account){
      window.app.$http.post(context.bpmRunTime+"/api/user/v1/user/getTokenByUserUserName?username="+account).then(resp=>{
        this.dialogTableVisible=false;
		    window.location.href = context.front+'/home?token='+resp.data.value;//拼接token
      });
    },
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
          if (valid) {
            window.app.$http.post(context.bpmRunTime+"/bpm/haiyaapi/SavePpbmb",{
              "fdmc": this.form.fdmc,
              "xm": this.form.xm,
              "lxfs": this.form.lxfs,
              "xqmj": this.form.xqmj,
              "xqwz": this.form.xqwz,
              "zw": this.form.zw,
              "bz": this.form.bz,
              "pppl":this.form.pppl
            }).then(resp=>{
              if(resp.data>0){
                this.$notify.success({title: "报名成功，我方工作人员将于近日与您联系。",duration: 4000});
                this.form.fdmc="";
                this.form.xm="";
                this.form.lxfs="";
                this.form.xqmj="";
                this.form.xqwz="";
                this.form.zw="";
                this.form.bz="";
                this.form.pppl="";
              }
            });
          } else {
            return false;
          }
      });
    },
    sendCode() {
    if(this.count==60){
      if(!(/^1[3456789]\d{9}$/.test(this.principal.mobile))){
        this.$notify.error({
          title: "手机号码不合法，请重新输入。",
          duration: 2000
        });
      }else{
        this.mobileCode = Math.floor(Math.random() * 10000);
        window.app.$http.post(context.bpmRunTime+"/api/user/v1/user/getMobileCode?mobile="+this.principal.mobile+"&code="+this.mobileCode).then(resp=>{
          if(resp.data.resCode=='500'){//用户不存在
            this.$notify.success({title: resp.data.resMsg,duration: 2000});
          }else{//用户存在
            this.count=59;//避免计时器未开始又重复点击
            // 模拟计时器
            if (this.timer) return;
            this.timer = setInterval(() => {
              if (this.count > 0) {
                this.message=this.count+'s 已发送'
                this.count--;
              } else {
                clearInterval(this.timer);
                this.timer = null;
                this.message='获取验证码';
                this.count=60;
                this.mobileCode = '';
              }
            }, 1000);
          }
        });
      }
    }else{
      this.$notify.success({
        title: "验证码已经发送，请勿重复发送。",
        duration: 2000
      });
    }
  },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    //获取系统默认配置 系统Logo、名称
    sysSetting() {
      const _this = this;
      let url =
        window.context.portal + "/sys/sysProperties/v1/getDecryptBySysSetting";
      this.$http.get(url).then((response) => {
        if (response && response.data && response.data.value) {
          _this.showTenant = true;
          let sysSettingData = JSON.parse(response.data.value);
          if (sysSettingData.frontName == "") {
            _this.companyName = _this.name;
          } else {
            _this.companyName = sysSettingData.frontName;
          }
          if (sysSettingData.ico.length > 0) {
            let ico = sysSettingData.ico;
            _this.showLogo = true;
            _this.logo =
              window.context.portal +
              "/system/file/v1/downloadFile?fileId=" +
              ico[0].id;
          }
        }
      });
    },
    querySearch(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }
      let queryFilter = {};
      queryFilter.pageBean = {
        page: 1,
        pageSize: 20,
        total: 0,
        showTotal: true,
      };
      let query = {
        property: "name_",
        value: queryString,
        group: "main",
        operation: "LIKE",
        relation: "AND",
      };
      if (!queryFilter.querys) {
        queryFilter.querys = [];
      }
      queryFilter.querys.push(query);

      this.$http
        .post(`${window.context.uc}/uc/tenantManage/v1/listJson`, queryFilter)
        .then((res) => {
          // 调用 callback 返回建议列表的数据
          cb(res.data.rows);
        });
    },
    handleSelect(item) {
      this.tenantName = item.name;
      this.principal.tenantId = item.id;
    },
    setRouterPath() {
      this.$store.dispatch("login/actionLoginAccount", this.principal.account);
      localStorage.setItem(
        this.principal.account + "loginRoutePath",
        this.$route.path
      );
    },
    submitForm_mobile(){
      if(!(/^1[3456789]\d{9}$/.test(this.principal.mobile))){
        this.$notify.error({title: "手机号码不合法，请重新输入。",duration: 2000});
        return;
      }
      if(!this.principal.code){
        this.$notify.error({title: "验证码不合法，请重新输入。",duration: 2000});
        return;
      }
      if(this.principal.code==this.mobileCode){
        // this.$notify.success({title: "验证码正确。",duration: 2000});
        window.app.$http.post(context.bpmRunTime+"/api/user/v1/user/getMobileTokenByUserUserName?mobile="+this.principal.mobile).then(resp=>{
          this.loginuser = resp.data;
          this.dialogTableVisible=true;
        });
      }else{
        this.$notify.error({title: "验证码错误。",duration: 2000});
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.inputGetFocus();
          this.setRouterPath();
          this.loading = true;
          this.$store
            .dispatch("login/loginByPrincipal", this.principal)
            .then((loginStatus) => {
              this.loading = false;
              if (loginStatus && loginStatus == true) {//登录成功
              sessionStorage.guide=true;//插入允许请求操作指引session
              sessionStorage.HolidayTips=true;//插入允许弹出节假日
                this.$router.push({
                  path: this.$route.query.redirect
                    ? this.$route.query.redirect
                    : "/",
                });
              } else if (loginStatus == false) {
                this.$router.push({
                  name: "resetPwdView",
                  params: { account: this.principal.account },
                });
              }
            })
            .catch((msg) => {
              this.loading = false;
              if (msg.startsWith("timeout of")) {
                msg = "登录超时";
              }
              this.responseError = msg;
            });
        } else {
          return false;
        }
      });
    },
    inputGetFocus() {
      this.responseError = "";
    },
    resetForm(formName) {
      this.responseError = "";
      this.$refs[formName].resetFields();
    },
  },
  created() {
    let USER_AGENT = navigator.userAgent.toLowerCase();
    let isChrome = /.*(chrome)\/([\w.]+).*/;
    if (!isChrome.test(USER_AGENT)) {
      this.isIeExplorer = true;
    }
  },
  components: { 
    langSelect,
    haiyaMails,
    newsText
   },
};
</script>
<style lang="scss" scoped>

.login {
  width: 400px;
  height: 230px;
  background: #fff;
  box-shadow: 2px 2px 3px #abb1b4;
  border-radius: 10px;
}

.login-system__name {
  font-size: 24px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #82838D;

  width: 100%;
  // margin-right: 10px;
  margin-top: 32px;
  vertical-align: bottom;
  height: 36px;
  line-height: 36px;
  text-align: left;
  font-style: italic;
}

.left_div {
  height: 100%;
  width: 50%;
  float: left;
}

.right_div {
  height: 100%;
  width: 50%;
  float: right;
}

.login-title {
  height: 30px;
  width: 100%;
  background: #024190;
  border-radius: 8px 8px 0 0;
}

.login-title span {
  line-height: 30px;
  font-weight: bold;
  font-size: 18px;
  padding-left: 20px;
  color: #fff;
}

.user-div {
  height: 35px;
  width: 280px;
  margin-top: 40px;
  margin-left: 80px;
  display: -webkit-flex;
  display: flex;
}

.user-div input {
  height: 25px;
  width: 100%;
  margin-left: 15px;
}

.pwd-div {
  height: 35px;
  width: 280px;
  margin-top: 20px;
  margin-left: 80px;
  display: -webkit-flex;
  display: flex;
}

.pwd-div input {
  height: 25px;
  width: 100%;
  margin-left: 15px;
}

.btn_wrap {
  display: flex;
  justify-content: center;
  margin-top: 36px;
  float: left;
}

.mobile_img_wrap {
  display: none;
  position: absolute;
  top: 48px;
  left: -56px;
  .img_item {
    width: 160px;
  }
}

.mobile_btn {
  position: relative;
  padding-right: 20px;
  color: #409EFF;
  &:hover{
    cursor: pointer;
    color: #409EFF;
    .mobile_img_wrap{
      display: block;
    }
  }
}

/deep/ .el-input__inner{
  width: 400px !important;
  height: 40px !important;
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
}

/deep/ .login_btn{
  span{
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
  }
}

/deep/ .el-tabs__nav-scroll{
  height: 56px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
}

/deep/ .el-tabs__header{
  margin:0px;
}

/deep/ .tabs__content{
  padding-left: 32px !important;
}

/deep/ .tabs_v1{
  .el-tabs__nav{
    padding-left: 45% !important;
    height: 56px;
    line-height: 56px;
  }
}

/deep/ .tabs_v2{
  .el-tabs__nav{
    padding-left: 32px !important;
    height: 56px;
    line-height: 56px;
  }
}

/deep/ .el-tabs__active-bar{
  display: none;
}

/deep/ .el-tabs__item{
  font-size: 18px !important;
  color: #9D9FAD;
}

/deep/ .el-tabs__item.is-active{
  font-size: 18px !important;
  color: #292B44;
}

/deep/ .el-tabs__item:hover{
  font-size: 18px !important;
  color: #292B44 !important;
}

/deep/ .el-input__inner{
  width: 306px !important;
}

/deep/ .el-textarea{
  width: 306px !important;
}

/deep/ .mobile{
  display: table-footer-group !important;
  .el-input__inner{
    width: 212px !important;
  }
}

//背景色设置为透明
/deep/ .el-input__wrapper{
  background-color:rgba(0,0,0,0);
}

//输入框颜色
/deep/ .el-input__inner {
  background-color: rgba(0, 0, 0, 0) !important;
    color: #292B44;
}

//历史记录后自动补充的颜色
/deep/ input:-webkit-autofill {
  -webkit-text-fill-color: #292B44;
  transition: background-color 5000s ease-out 0.5s;
}

//提示框的字体颜色
/deep/ input::-webkit-input-placeholder {
  color: #292B44;
}
/deep/ .el-table th.is-leaf{
  text-align: left !important;
}

/deep/ .el-table td{
  text-align: center !important;
}

/deep/ .el-dialog__body{
  padding: 8px 8px 16px 8px !important;
}
</style>
